import * as React from 'react'
import Joi, { Schema } from 'joi'
import { Color } from 'react-color'
import { t } from 'i18next'
import {
  Close as CloseIcon,
  ExpandMore as SelectIcon,
} from '@mui/icons-material'
import {
  Box,
  Checkbox,
  Dialog,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import Divider from '@mui/material/Divider'
import Chip from '@mui/material/Chip'
import { Stepper } from '../Stepper'
import { colorBackground } from '../../mui'
import { useDispatch } from '../../store'
import { postWorkflow, putWorkflow } from '../../store/package/actionCreator'
import { PreviewLookup } from '../../container/package/PreviewLookup'
import {
  phones,
  postLookups,
  socials,
  usePackagePopup,
  deepWebLookups,
  combinedPhones,
  combinedEmails,
  combinedNames,
  combinedIds,
  faceSearches,
  advancedCollectionLookups,
  sentimentAnalysys,
  findClone,
  sniperAPI,
  kyc,
  ip_geo,
  geolocation_by_number,
  web_collection,
  nameByCountry,
  phoneList,
  advCollectionPersonWallLookups,
  psychoProfile,
  api_v2_x,
  api_v2_instagram,
  api_v2_linkedin,
  sn_api_profile,
  sn_api_group_profile,
  lookup_phone_verification,
  fbMobileCollectorLookups,
  instaMobileCollectorLookups,
  nameApi,
  crolo_x,
  crolo_vk,
  irbis_tiktok,
  crolo_ok,
  irbis_criminal,
  ssn_trace, 
  nat_crim_check, 
  pep,
  bluesky,
  court_records,
  cryptoWalletScreening,
  adid,
  group_members,
  emailList,
  adid_by_phone,
  adid_location,
  image_insize,
  profiler,
  openSanctions,
  openSanctionsPep,
  openSanctionsRegulatory,
  postsByKeywords,
  postsComments,
  publicCompanyInfo,
  irbisProConcludeReport,
  regionMonitoring,
  regionMonitoringEntitiesExtract,
} from '../../hook/usePackagePopup'
import {
  FormState,
  latinOnly,
  validateForm,
  ErrorsState,
} from '../../function/validation'
import { FormError } from '../FormError'
import { InputCheckbox } from '../InputCheckbox'
import sprite_ from '../../sass/sprite.module.sass'
import { genRandomHex, getSourceName } from '../../function/common'
import { InputColor } from '../../container/package/InputColor'
import {
  Workflow,
  WorkflowType,
  Phone,
  Social,
  Source,
  DeepWeb,
  WebInt,
  CombinedPhone,
  CombinedEmail,
  CombinedNames,
  CombinedId,
  FaceSearch,
  AdvancedCollectionFacebook,
  FacebookMobileCollector,
  SentimentAnalysys,
  FindClone,
  KYC,
  WEB_Collection,
  IPGeo,
  IPGeoNumber,
  NameByCountry,
  SniperAPI,
  PhoneList,
  EmailList,
  AdvCollectionFbPersonWall,
  PsychoProfile,
  APIv2X,
  APIv2Instagram,
  APIv2LinkedIn,
  SNApiProfile,
  SNApiWebintGroupProfile,
  LookupPhoneVerification,
  NameApi,
  CroloX,
  InstagramMobileCollector,
  CroloVk,
  IrbisTikTok,
  CroloOk,
  IrbisCriminal,
  SsnTrace,
  NatCrimCheck,
  Pep,
  IrbisBlueSky,
  CourtRecords,
  CryptoWalletScreening,
  Adid,
  GroupMembers,
  AdidByPhone,
  AdidLocation,
  ImageInsize,
  Profiler,
  OpenSanctions,
  OpenSanctionsPep,
  OpenSanctionsRegulatory,
  PostsByKeywords,
  PostsAndComments,
  PublicCompanyInfo,
  IrbisProConcludeReport,
  RegionMonitoring,
  RegionMonitoringEntitiesExtract,
} from '../../store/package/reducer'
import { PopupActions } from './PopupActions'
import { TableRef } from '../datatable/types'
import { clearFieldError } from '../../store/common/actionCreator'

import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { CountrySingleSelect } from './select-country/CountrySingleSelect'

const schema: Schema = Joi.object({
  type: Joi.allow('phone', 'name', 'post', 'deepweb', 'webint', 'web_data_search', 'fb_person_wall_keyword'),
  title: latinOnly.label(t('field.label.title')),
  subTitle: latinOnly.label(t('field.label.subTitle')),
  price: Joi.number()
  .required()
  .min(0.01)
  .max(99)
  .label(t('field.label.price')),
  fakeCheckPrice: Joi.allow(null),
  reportCountry: Joi.allow('profiler'),
  aiSummarizingPrice: Joi.allow(null),
  maxNum: Joi.allow(null),
  sources: Joi.array().min(1).label(t('field.label.sources')),
  input: latinOnly.max(16).label(t('field.label.input')),
  inputIP: Joi.allow(null).label(t('field.label.inputIP')),
  inputPhone: Joi.allow(null).label(t('field.label.inputPhone')),
  button: latinOnly.max(12).label(t('field.label.button')),
  color: Joi.string().required(),
  country: Joi.allow(null),
})

type Props = {
  mode: 'create' | 'edit'
  onClose: () => void
  tableRef: React.RefObject<TableRef>
  data?: Workflow
}

const webIntParams : string[] = ['quotaprofiler-lookup','quotaprofiler-crawler','quotaprofiler-cases','quotaprofiler-periodic','quotaprofiler-monitoring',
'quotawebint-lookup','quotawebint-crawler','quotawebint-cases','quotawebint-periodic','quotawebint-monitoring']

export function PopupWorkflow({ mode, tableRef, onClose, data }: Props) {
  const dispatch = useDispatch()
  const { initSourcePhone, initSourceSocials, initSourceNameApi, initSourceCroloX, initSourceCroloVk, initSourceCroloOk, initSourceIrbisTikTok, initSourceBlueSky,
    initSourceDeepWeb, initSourceWebInt, initCombinePhones, initCombineEmails, initCombineNames, initCombineId, initFaceSearch, initSourceAdid, initSourceByPhone, initSourceLocation,
    initAdvancedCollection, initFbMobileCollector, initInstaMobileCollector, initAdvCollectionFbPersonWall, initSentimentAnalysys, initFindClone, initSniperApi,
    initKYC, initIPGeo, initIPGeoByNumber, initWebCollection, initNameByCountry, initPhoneList, initEmailList, initPsychoProfile, initAPIv2X, initAPIv2Instagram,
    initAPIv2LinkedIn, initSourceSnAPIProfiler, initSourceSNApiWebintGroupProfile, initSourceLookupPhoneValidator, initSourceIrbisCriminal,
    initSourceSsnTrace, initSourceNatCrimCheck, initSourcePep, initSourceCourtRecords, initSourceCryptoWalletScreening, initSourceRegionMonitoring, initSourceRegionMonitoringEntitiesExtract,
    initSourceIrbisProConcludeReport, initSourceGroupMembers, initSourceImageInsize, initSourceProfiler, initSourceOpenSanctions, initSourceOpenSanctionsPep, 
    initSourceOpenSanctionsRegulatory, initSourcePostsByKeywords, initSourcePostsComments, initSourcePublicCompanyInfo, isSourceChecked } = usePackagePopup()

  const [activeStep, setActiveStep] = React.useState(0)

  const [type, setType] = React.useState<WorkflowType>(data?.type || 'phone')
  
  const [title, setTitle] = React.useState(data?.title || '')
  const [subTitle, setSubTitle] = React.useState(data?.subTitle || '')
  const [price, setPrice] = React.useState(data?.price || 1)
  const [maxNum, setMaxNum] = React.useState(data?.maxNum || 0)
  const [fakeCheckPrice, setFakeCheckPrice] = React.useState(data?.fakeCheckPrice || 0)
  const [isFakeCheck, setIsfakeCheck] = React.useState(data?.fakeCheckPrice ? true : false)
  const [aiSummarizingPrice, setAiSummarizingPrice] = React.useState(data?.aiSummarizingPrice || 0)
  const [isAiSummarizing, setIsAiSummarizing] = React.useState(data?.aiSummarizingPrice ? true : false)

  function useInitSource<T>(initializer: (sources: any, type: any) => T[], data: any, type: any) {
    return React.useState<T[]>(() => initializer(data?.sources, type))
  }

const [sourcePhone, setSourcePhone] = useInitSource<Phone>(initSourcePhone, data, type)
const [sourceSocial, setSourceSocial] = useInitSource<Social>(initSourceSocials, data, type)
const [sourceNameApi, setSourceNameApi] = useInitSource<NameApi>(initSourceNameApi, data, type)
const [sourceCroloX, setSourceCroloX] = useInitSource<CroloX>(initSourceCroloX, data, type)
const [sourceCroloVk, setSourceCroloVk] = useInitSource<CroloVk>(initSourceCroloVk, data, type)
const [sourceCroloOk, setSourceCroloOk] = useInitSource<CroloOk>(initSourceCroloOk, data, type)
const [sourceIrbisCriminal, setSourceIrbisCriminal] = useInitSource<IrbisCriminal>(initSourceIrbisCriminal, data, type)
const [sourceSsnTrace, setSourceSsnTrace] = useInitSource<SsnTrace>(initSourceSsnTrace, data, type)
const [sourceNatCrimCheck, setSourceNatCrimCheck] = useInitSource<NatCrimCheck>(initSourceNatCrimCheck, data, type)
const [sourcePep, setSourcePepCheck] = useInitSource<Pep>(initSourcePep, data, type)
const [sourceCourtRecords, setSourceCourtRecordsCheck] = useInitSource<CourtRecords>(initSourceCourtRecords, data, type)
const [sourceCryptoWalletScreening, setSourceCryptoWalletScreening] = useInitSource<CryptoWalletScreening>(initSourceCryptoWalletScreening, data, type)
const [sourceRegionMonitoring, setSourceRegionMonitoring] = useInitSource<RegionMonitoring>(initSourceRegionMonitoring, data, type)
const [sourceRegionMonitoringEntitiesExtract, setSourceRegionMonitoringEntitiesExtract] = useInitSource<RegionMonitoringEntitiesExtract>(initSourceRegionMonitoringEntitiesExtract, data, type)

const [sourceIrbisProConcludeReport, setSourceIrbisProConcludeReport] = useInitSource<IrbisProConcludeReport>(initSourceIrbisProConcludeReport, data, type)
const [sourceIrbisTikTok, setSourceIrbisTikTok] = useInitSource<IrbisTikTok>(initSourceIrbisTikTok, data, type)
const [sourceAdid, setSourceAdid] = useInitSource<Adid>(initSourceAdid, data, type)
const [sourceAdidByPhone, setSourceAdidByPhone] =  useInitSource<AdidByPhone>(initSourceByPhone, data, type)
const [sourceAdidLocation, setSourceAdidLocation] =  useInitSource<AdidLocation>(initSourceLocation, data, type)
const [sourceImageInsize, setSourceImageInsize] = useInitSource<ImageInsize>(initSourceImageInsize, data, type)
const [sourceProfiler, setSourceProfiler] = useInitSource<Profiler>(initSourceProfiler, data, type)
const [sourceOpenSanctions, setSourceOpenSanctions] = useInitSource<OpenSanctions>(initSourceOpenSanctions, data, type)
const [sourceOpenSanctionsPep, setSourceOpenSanctionsPep] = useInitSource<OpenSanctionsPep>(initSourceOpenSanctionsPep, data, type)
const [sourceOpenSanctionsRegulatory, setSourceOpenSanctionsRegulatory] = useInitSource<OpenSanctionsRegulatory>(initSourceOpenSanctionsRegulatory, data, type)
const [sourcePostsByKeywords, setSourcePostsByKeywords] = useInitSource<PostsByKeywords>(initSourcePostsByKeywords, data, type)
const [sourcePostsComments, setSourcePostsComments] = useInitSource<PostsAndComments>(initSourcePostsComments, data, type)
const [sourcePublicCompanyInfo, setSourcePublicCompanyInfo] = useInitSource<PublicCompanyInfo>(initSourcePublicCompanyInfo, data, type) 

const [sourceGroupMembers, setSourceGroupMembers] = useInitSource<GroupMembers>(initSourceGroupMembers, data, type)
const [sourceBlueSky, setSourceBlueSky] = useInitSource<IrbisBlueSky>(initSourceBlueSky, data, type)
const [sourceDeepWeb, setSourceDeepWeb] = useInitSource<DeepWeb>(initSourceDeepWeb, data, type)
const [sourceWebInt, setSourceWebInt] = useInitSource<WebInt>(initSourceWebInt, data, type)
const [sourceCombinedPhones, setSourceCombinePhones] = useInitSource<CombinedPhone>(initCombinePhones, data, type)
const [sourceCombinedEmails, setSourceCombineEmails] = useInitSource<CombinedEmail>(initCombineEmails, data, type)
const [sourceCombinedNames, setSourceCombineNames] = useInitSource<CombinedNames>(initCombineNames, data, type)
const [sourceCombinedId, setSourceCombineId] = useInitSource<CombinedId>(initCombineId, data, type)
const [sourceFaceSearch, setSourceFaces] = useInitSource<FaceSearch>(initFaceSearch, data, type)
const [sourceAdvancedCollection, setSourceAdvancedCollection] = useInitSource<AdvancedCollectionFacebook>(initAdvancedCollection, data, type)
const [sourceFbMobileCollector, setSourceFbMobileCollector] = useInitSource<FacebookMobileCollector>(initFbMobileCollector, data, type)
const [sourceInstaMobileCollector, setSourceInstaMobileCollector] = useInitSource<InstagramMobileCollector>(initInstaMobileCollector, data, type)
const [sourceAdvCollectionSourcePersonWall, setAdvCollectionSourcePersonWall] = useInitSource<AdvancedCollectionFacebook>(initAdvCollectionFbPersonWall, data, type)
const [sourceSentiment, setSourceSentiment] = useInitSource<SentimentAnalysys>(initSentimentAnalysys, data, type)
const [sourceFindClone, setSourceFindClone] = useInitSource<FindClone>(initFindClone, data, type)
const [sourceSniperApi, setSourceSniperApi] = useInitSource<SniperAPI>(initSniperApi, data, type)
const [sourceKYC, setSourceKYC] = useInitSource<KYC>(initKYC, data, type)
const [sourceWebCollection, setSourceWebCollection] = useInitSource<WEB_Collection>(initWebCollection, data, type)
const [sourceIPGeo, setSourceIPGeo] = useInitSource<IPGeo>(initIPGeo, data, type)
const [sourceIPGeoByNumber, setSourceIPGeoByNumber] = useInitSource<IPGeoNumber>(initIPGeoByNumber, data, type)
const [sourcePsychoProfile, setSourcePsychoProfile] = useInitSource<PsychoProfile>(initPsychoProfile, data, type)
const [sourcePhoneList, setSourcePhoneList] = useInitSource<PhoneList>(initPhoneList, data, type)
const [sourceEmailList, setSourceEmailList] = useInitSource<EmailList>(initEmailList, data, type)
const [sourceNameByCountry, setSourceNameByCountry] = useInitSource<NameByCountry>(initNameByCountry, data, type)
const [sourceAPIv2X, setSourceAPIv2X] = useInitSource<APIv2X>(initAPIv2X, data, type)
const [sourceAPIv2Instagram, setSourceAPIv2Instagram] = useInitSource<APIv2Instagram>(initAPIv2Instagram, data, type)
const [sourceAPIv2LinkedIn, setSourceAPIv2LinkedIn] = useInitSource<APIv2LinkedIn>(initAPIv2LinkedIn, data, type)
const [sourceSnAPIProfiler, setSourceSnAPIProfiler] = useInitSource<SNApiProfile>(initSourceSnAPIProfiler, data, type)
const [sourceSNApiWebintGroupProfile, setSourceSNApiWebintGroupProfile] = useInitSource<SNApiWebintGroupProfile>(initSourceSNApiWebintGroupProfile, data, type)
const [sourceLookupPhoneValidator, setSourceLookupPhoneValidator] = useInitSource<LookupPhoneVerification>(initSourceLookupPhoneValidator, data, type)

  const getQuotaValue = (str : string) : number => {
    if (type === 'webint' || type === 'additional_quotas') {
      try {
        const obj = JSON.parse(input)
        if (str in obj)
        return obj[str]
      } catch (e) {
        return 1
      }
    }
    return 1
  }  
  
  const [input, setInput] = React.useState( 
      data?.input && type === 'ipgeo_number' 
        && JSON.parse(data?.input).phone ? JSON.parse(data?.input).phone : data?.input || '')

  const [inputIP, setInputIP] = React.useState(
    data?.input && type === 'ipgeo_number' 
        && JSON.parse(data?.input).ip ? JSON.parse(data?.input).ip : data?.input || '')

  const [button, setButton] = React.useState(data?.button || '')
  const [color, setColor] = React.useState<Color>(
    data?.color || genRandomHex(6),
  )
  const [errors, setErrors] = React.useState<ErrorsState>(null)

  type CountryCode = "US" | "IL";

  const [reportCountry, setCountry] = React.useState<CountryCode | null>(() => {
    const input: any = data?.input
    if (!input) return null
    try {
      if (data?.type === 'profiler' && typeof JSON.parse(input) === "object") {
        const parsed = JSON.parse(input)
        if (parsed?.reportCountry) {
          const rc = parsed?.reportCountry
          return rc === "US" || rc === "IL" ? rc : null
        }
      } else {
        return null
      }
    } catch {
      return null
    }
  })
  
  const  [quotaProfilerLookup, setQuotaProfilerLookup] = React.useState(getQuotaValue("quotaProfilerLookup").toString())
  const  [quotaProfilerCrawlers, setQuotaProfilerCrawlers] = React.useState(getQuotaValue("quotaProfilerCrawlers").toString())
  const  [quotaProfilerCases, setQuotaProfilerCases] = React.useState(getQuotaValue("quotaProfilerCases").toString())
  const  [quotaProfilerMonitoring, setQuotaProfilerMonitoring] = React.useState(getQuotaValue("quotaProfilerMonitoring").toString())
  const  [quotaProfilerPeriodic, setQuotaProfilerPeriodic] = React.useState(getQuotaValue("quotaProfilerPeriodic").toString())

  const  [quotaWebIntLookup, setQuotaWebIntLookup] = React.useState(getQuotaValue("quotaWebIntLookup").toString())
  const  [quotaWebIntCrawlers, setQuotaWebIntCrawlers] = React.useState(getQuotaValue("quotaWebIntCrawlers").toString())
  const  [quotaWebIntCases, setQuotaWebIntCases] = React.useState(getQuotaValue("quotaWebIntCases").toString())
  const  [quotaWebIntMonitoring, setQuotaWebIntMonitoring] = React.useState(getQuotaValue("quotaWebIntMonitoring").toString())
  
  //this value is for profiler and webint
  const  [quotaWebIntPeriodic, setQuotaWebIntPeriodic] = React.useState(getQuotaValue("quotaWebIntPeriodic").toString())  

  const  [quotaTrialProfilerLookup, setQuotaTrialProfilerLookup] = React.useState(getQuotaValue("quotaTrialProfilerLookup").toString())
  const  [quotaTrialProfilerCrawlers, setQuotaTrialProfilerCrawlers] = React.useState(getQuotaValue("quotaTrialProfilerCrawlers").toString())
  const  [quotaTrialProfilerCases, setQuotaTrialProfilerCases] = React.useState(getQuotaValue("quotaTrialProfilerCases").toString())
  const  [quotaTrialWebIntCrawlers, setQuotaTrialWebIntCrawlers] = React.useState(getQuotaValue("quotaTrialWebIntCrawlers").toString())
  const  [quotaTrialWebIntCases, setQuotaTrialWebIntCases] = React.useState(getQuotaValue("quotaTrialWebIntCases").toString())
  const  [quotaTrialWebIntMonitoring, setQuotaTrialWebIntMonitoring] = React.useState(getQuotaValue("quotaTrialWebIntMonitoring").toString())
  
  //this value is for profiler and webint
  const  [quotaTrialWebIntPeriodic, setQuotaTrialWebIntPeriodic] = React.useState(getQuotaValue("quotaTrialWebIntPeriodic").toString())

  //Additional Qoutas for WebInt package
  const [additionalProfilerLookup, setAdditionalProfilerLookup] = React.useState(getQuotaValue("additionalProfilerLookup").toString())
  const [additionalProfilerCrawlers, setAdditionalProfilerCrawlers] = React.useState(getQuotaValue("additionalProfilerCrawlers").toString())
  const [additionalProfilerCases, setAdditionalProfilerCases] = React.useState(getQuotaValue("additionalProfilerCases").toString())
  const [additionalProfilerMonitoring, setAdditionalProfilerMonitoring] = React.useState(getQuotaValue("additionalProfilerMonitoring").toString())
  const [additionalProfilerPeriodic, setAdditionalProfilerPeriodic] = React.useState(getQuotaValue("additionalProfilerPeriodic").toString())
  const [additionalWebIntLookup, setAdditionalWebIntLookup] = React.useState(getQuotaValue("additionalWebIntLookup").toString())
  const [additionalWebIntCrawlers, setAdditionalWebIntCrawlers] = React.useState(getQuotaValue("additionalWebIntCrawlers").toString())
  const [additionalWebIntCases, setAdditionalWebIntCases] = React.useState(getQuotaValue("additionalWebIntCases").toString())
  const [additionalWebIntMonitoring, setAdditionalWebIntMonitoring] = React.useState(getQuotaValue("additionalWebIntMonitoring").toString())
  const [additionalWebIntPeriodic, setAdditionalWebIntPeriodic] = React.useState("0")


  React.useEffect(() => {
    setErrors(null)
    dispatch(clearFieldError)
  }, [
    dispatch,
    type,
    title,
    subTitle,
    price,
    maxNum,
    sourcePhone,
    fakeCheckPrice,
    reportCountry,
    aiSummarizingPrice,
    sourceSocial,
    sourceNameApi,
    sourceCroloX,
    sourceCroloVk,
    sourceCroloOk,
    sourceIrbisCriminal,
    sourceSsnTrace,
    sourceNatCrimCheck,
    sourcePep,
    sourceCourtRecords,
    sourceCryptoWalletScreening,
    regionMonitoring,
    regionMonitoringEntitiesExtract,
    sourceIrbisProConcludeReport,
    sourceIrbisTikTok,
    sourceDeepWeb,
    sourceCombinedPhones,
    sourceCombinedEmails,
    sourceCombinedNames,
    sourceCombinedId,
    sourceFaceSearch,
    sourceSniperApi,
    sourceAdvancedCollection,
    sourceFbMobileCollector,
    sourceAdvCollectionSourcePersonWall,
    sourceSentiment,
    sourcePsychoProfile,
    sourceAPIv2X, 
    sourceAPIv2Instagram,
    sourceAPIv2LinkedIn,
    sourceSnAPIProfiler,
    sourceSNApiWebintGroupProfile,
    sourceLookupPhoneValidator,
    sourcePublicCompanyInfo,
    input,
    quotaProfilerLookup,
    quotaProfilerCrawlers,
    quotaProfilerCases,
    quotaProfilerMonitoring,
    quotaProfilerPeriodic,
    quotaWebIntLookup,
    quotaWebIntCrawlers,
    quotaWebIntCases,
    quotaWebIntMonitoring,
    quotaWebIntPeriodic,
    quotaTrialProfilerLookup,
    quotaTrialProfilerCrawlers,
    quotaTrialProfilerCases,
    quotaTrialWebIntCrawlers,
    quotaTrialWebIntCases,
    quotaTrialWebIntMonitoring,
    quotaTrialWebIntCrawlers,
    additionalProfilerLookup,
    additionalProfilerCrawlers,
    additionalProfilerCases,
    additionalProfilerMonitoring,
    additionalProfilerPeriodic,
    additionalWebIntLookup,
    additionalWebIntCrawlers,
    additionalWebIntCases,
    additionalWebIntMonitoring,
    additionalWebIntPeriodic,
    button,
    color,
  ])
  const sources: Source[] = [...sourcePhone, ...sourceSocial, ...sourceNameApi, ...sourceCroloX, ...sourceCroloVk, ...sourceIrbisCriminal, ...sourceCroloOk, ...sourceDeepWeb, ...sourceCombinedPhones, ...sourceCombinedEmails, 
    ...sourceCombinedNames, ...sourceCombinedId, ...sourceFaceSearch, ...sourceAdvancedCollection, ...sourceFbMobileCollector, ...sourceAdvCollectionSourcePersonWall, ...sourceFindClone, ...sourceKYC, 
    ...sourceWebCollection, ...sourceIPGeo, ...nameByCountry, ...sourceSniperApi, ...sourceIPGeoByNumber, ...sourcePsychoProfile, ...sourceAPIv2X, 
    ...sourceAPIv2Instagram, ...sourceAPIv2LinkedIn, ...sourceSnAPIProfiler, ...sourceSNApiWebintGroupProfile, ...sourceLookupPhoneValidator, ...sourceIrbisTikTok,
    ...sourceSsnTrace, ...sourceNatCrimCheck, ...sourcePep, ...sourceCourtRecords, 
    ...sourceCryptoWalletScreening, ...sourceRegionMonitoring, ...sourceRegionMonitoringEntitiesExtract,
    ...sourceIrbisProConcludeReport, ...sourcePostsByKeywords, ...sourcePostsComments, ...sourcePublicCompanyInfo]

  const requestData: FormState = {
    type,
    price,
    sources,
    fakeCheckPrice,
    reportCountry,
    aiSummarizingPrice,
    maxNum,
    color,
    title: title.trim(),
    subTitle: subTitle.trim(),
    input: input.trim(),
    inputIP: inputIP.trim(),
    button: button.trim(),
  }

  function handleTypeChange(type: WorkflowType) {
    setSourcePhone([])
    setSourceSocial([])
    setSourceDeepWeb([])
    setSourceWebInt([])
    setSourceAdvancedCollection([])
    setAdvCollectionSourcePersonWall([])
    setSourceFaces([])
    setSourceSentiment([])
    setSourceFindClone([])
    setSourceSniperApi([])
    setSourceKYC([])
    setSourceWebCollection([])
    setSourceIPGeo([])
    setSourceIPGeoByNumber([])
    setSourceNameByCountry([])
    setSourceAPIv2X([])
    setSourceAPIv2Instagram([])
    setSourceSsnTrace([])
    setSourceNatCrimCheck([])
    setSourcePepCheck([])
    setSourceCourtRecordsCheck([])
    setSourceCryptoWalletScreening([])
    setSourceRegionMonitoring([])
    setSourceRegionMonitoringEntitiesExtract([])
    setSourceOpenSanctions([])
    setSourceOpenSanctionsPep([])
    setSourceOpenSanctionsRegulatory([])
    setSourcePostsByKeywords([])
    setSourcePostsComments([])
    setSourcePublicCompanyInfo([])
    setType(type)
  }

  function handleAdvCollectionSourcePersonWall(source: AdvCollectionFbPersonWall) {
    setAdvCollectionSourcePersonWall((state) => {
      const index = state.indexOf(source)
      const newState = [...state]
      if (index > -1) {
        newState.splice(index, 1)
        return newState
      } else {
        return [...state, source]
      }
    })
  }

  function createToggleHandler<T>(setState: React.Dispatch<React.SetStateAction<T[]>>) {
    return (source: T) => {
      setState((state) => {
        const index = state.indexOf(source)
        if (index > -1) {
          return state.filter((_, i) => i !== index)
        } else {
          return [...state, source]
        }
      })
    }
  }

const handleKYCChange = createToggleHandler<KYC>(setSourceKYC)
const handleWebCollectionChange = createToggleHandler<WEB_Collection>(setSourceWebCollection)
const handleAPIv2XChange = createToggleHandler<APIv2X>(setSourceAPIv2X)
const handleAPIv2InstagramChange = createToggleHandler<APIv2Instagram>(setSourceAPIv2Instagram)
const handleAPIv2LinkedInChange = createToggleHandler<APIv2LinkedIn>(setSourceAPIv2LinkedIn)
const handleSnAPIProfilerChange = createToggleHandler<SNApiProfile>(setSourceSnAPIProfiler)
const handleSNApiWebintGroupProfileChange = createToggleHandler<SNApiWebintGroupProfile>(setSourceSNApiWebintGroupProfile)
const handleIPGeoChange = createToggleHandler<IPGeo>(setSourceIPGeo)
const handleIPGeoByNumberChange = createToggleHandler<IPGeoNumber>(setSourceIPGeoByNumber)
const handleNameByCountry = createToggleHandler<NameByCountry>(setSourceNameByCountry)
const handleFindCloneChange = createToggleHandler<FindClone>(setSourceFindClone)
const handleSniperApiChange = createToggleHandler<SniperAPI>(setSourceSniperApi)
const handleSentimentAnalysysChange = createToggleHandler<SentimentAnalysys>(setSourceSentiment)
const handleListPhoneSourceChange = createToggleHandler<PhoneList>(setSourcePhoneList)
const handleListEmailSourceChange = createToggleHandler<EmailList>(setSourceEmailList)
const handlePhoneSourceChange = createToggleHandler<Phone>(setSourcePhone)
const handleCombinePhoneSourceChange = createToggleHandler<CombinedPhone>(setSourceCombinePhones)
const handleCombineNamesSourceChange = createToggleHandler<CombinedNames>(setSourceCombineNames)
const handleFaceSearch = createToggleHandler<FaceSearch>(setSourceFaces)
const handleCombineidSourceChange = createToggleHandler<CombinedId>(setSourceCombineId)
const handleCombineEmailsSourceChange = createToggleHandler<CombinedEmail>(setSourceCombineEmails)
const handleSocialSourceChange = createToggleHandler<Social>(setSourceSocial)
const handleNameApiSourceChange = createToggleHandler<NameApi>(setSourceNameApi)
const handleCroloXSourceChange = createToggleHandler<CroloX>(setSourceCroloX)
const handleCroloVkSourceChange = createToggleHandler<CroloVk>(setSourceCroloVk)
const handleCroloOkSourceChange = createToggleHandler<CroloOk>(setSourceCroloOk)
const handleIrbisCriminalSourceChange = createToggleHandler<IrbisCriminal>(setSourceIrbisCriminal)
const handleSsnTraceSourceChange = createToggleHandler<SsnTrace>(setSourceSsnTrace)
const handleNatCrimCheckSourceChange = createToggleHandler<NatCrimCheck>(setSourceNatCrimCheck)
const handlePepSourceChange = createToggleHandler<Pep>(setSourcePepCheck)
const handleCourtRecordsSourceChange = createToggleHandler<CourtRecords>(setSourceCourtRecordsCheck)
const handleCryptoWalletScreeningSourceChange = createToggleHandler<CryptoWalletScreening>(setSourceCryptoWalletScreening)
const handleRegionMonitoringSourceChange = createToggleHandler<RegionMonitoring>(setSourceRegionMonitoring)
const handleRegionMonitoringEntitiesExtractSourceChange = createToggleHandler<RegionMonitoringEntitiesExtract>(setSourceRegionMonitoringEntitiesExtract)
const handleIrbisproConcludeReportSourceChange = createToggleHandler<IrbisProConcludeReport>(setSourceIrbisProConcludeReport)
const handleIrbisTikTokSourceChange = createToggleHandler<IrbisTikTok>(setSourceIrbisTikTok)
const handleAdidSourceChange = createToggleHandler<Adid>(setSourceAdid)
const handleAdidByPhoneSourceChange = createToggleHandler<AdidByPhone>(setSourceAdidByPhone)
const handleAdidLocationSourceChange = createToggleHandler<AdidLocation>(setSourceAdidLocation)
const handleGroupMembersSourceChange = createToggleHandler<GroupMembers>(setSourceGroupMembers)
const handleIrbisBlueSkySourceChange = createToggleHandler<IrbisBlueSky>(setSourceBlueSky)
const handleDeepWebChange = createToggleHandler<DeepWeb>(setSourceDeepWeb)
const handleAddvancedSourceChange = createToggleHandler<AdvancedCollectionFacebook>(setSourceAdvancedCollection)
const handleFbMobileCollectorSorceChange = createToggleHandler<FacebookMobileCollector>(setSourceFbMobileCollector)
const handleInstaMobileCollectorSorceChange = createToggleHandler<InstagramMobileCollector>(setSourceInstaMobileCollector)
const handlePsychoProfileChange = createToggleHandler<PsychoProfile>(setSourcePsychoProfile)
const handleImageInsize= createToggleHandler<ImageInsize>(setSourceImageInsize)
const handleProfiler= createToggleHandler<Profiler>(setSourceProfiler)
const handleOpenSanctions= createToggleHandler<OpenSanctions>(setSourceOpenSanctions)
const handleOpenSanctionsPep= createToggleHandler<OpenSanctionsPep>(setSourceOpenSanctionsPep)
const handleOpenSanctionsRegulatory= createToggleHandler<OpenSanctionsRegulatory>(setSourceOpenSanctionsRegulatory)
const handlePostsByKeywords = createToggleHandler<PostsByKeywords>(setSourcePostsByKeywords)
const handlePostsComments = createToggleHandler<PostsAndComments>(setSourcePostsComments)
const handleLookupPhoneValidator = createToggleHandler<LookupPhoneVerification>(setSourceLookupPhoneValidator)
const handlePublicCompanyInfo = createToggleHandler<PublicCompanyInfo>(setSourcePublicCompanyInfo)

  function handleFakeCheckPrice(
    e: React.SyntheticEvent<Element, Event>,
    checked: boolean,
  ) {
    if (checked) {
      setIsfakeCheck(true)
    } else {
      setIsfakeCheck(false)
      setFakeCheckPrice(0)
      setAiSummarizingPrice(0)
    }
  }

  function handleAIsummarizingPrice(
    e: React.SyntheticEvent<Element, Event>,
    checked: boolean,
  ) {
    if (checked) {
      setIsAiSummarizing(true)
    } else {
      setIsAiSummarizing(false)
      setFakeCheckPrice(0)
    }
  }

  const sourcesByType: Record<WorkflowType, any> = {
    phone: sourcePhone,
    name: sourceSocial,
    name_api: sourceNameApi,
    post: sourceSocial,
    deepweb: sourceDeepWeb,
    face_search: sourceFaceSearch,
    combined_phone: sourceCombinedPhones,
    combined_name: sourceCombinedNames,
    combined_id: sourceCombinedId,
    combined_email: sourceCombinedEmails,
    web_data_search: sourceAdvancedCollection,
    sentiment_analysys: sourceSentiment,
    irbis_eye: sourceFindClone,
    photo_searcher: sourceSniperApi,
    kyc: sourceKYC,
    web_collection: sourceWebCollection,
    ip_geo: sourceIPGeo,
    ipgeo_number: sourceIPGeoByNumber,
    name_by_country: sourceNameByCountry,
    phone_list: sourcePhoneList,
    email_list: sourceEmailList,
    fb_person_wall_keyword: sourceAdvCollectionSourcePersonWall,
    psycho_profile: sourcePsychoProfile,
    psycho_profile_summary: sourcePsychoProfile,
    api_v2_x: sourceAPIv2X,
    api_v2_instagram: sourceAPIv2Instagram,
    api_v2_linkedin: sourceAPIv2LinkedIn,
    sn_api_profiler: sourceSnAPIProfiler,
    sn_api_group_profiler: sourceSNApiWebintGroupProfile,
    lookup_phone_verification: sourceLookupPhoneValidator,
    lookup_phone_name_verification: sourceCombinedPhones,
    real_phone: sourceCombinedPhones,
    sn_api_profiler_fb_friends: ['osintFbFriends'],
    sn_api_profiler_fb_posts: ['osintFbPosts'],
    sn_api_profiler_insta_friends: ['osintInstaFriends'],
    sn_api_profiler_insta_posts: ['osintInstaPosts'],
    irbis_facebook: sourceFbMobileCollector,
    crolo_x: sourceCroloX,
    crolo_vk: sourceCroloVk,
    crolo_ok: sourceCroloOk,
    irbis_criminal: sourceIrbisCriminal,
    ssn_trace: sourceSsnTrace,
    nat_crim_check: sourceNatCrimCheck,
    pep: sourcePep,
    court_records: sourceCourtRecords,
    crypto_wallet_screening: sourceCryptoWalletScreening,
    region_monitoring: sourceRegionMonitoring,
    region_monitoring_entities_extract: sourceRegionMonitoringEntitiesExtract,
    irbispro_conclude_report: sourceIrbisProConcludeReport,
    adid: sourceAdid,
    adid_by_phone: sourceAdidByPhone,
    adid_location: sourceAdidLocation,
    irbis_tiktok: sourceIrbisTikTok,
    bluesky_v3: sourceBlueSky,
    irbis_instagram: sourceInstaMobileCollector,
    group_members: sourceGroupMembers,
    webint: undefined,
    additional_quotas: undefined,
    image_insize: sourceImageInsize,
    profiler: sourceProfiler,
    sanctions_person_company: sourceOpenSanctions,
    sanctions_pep: sourceOpenSanctionsPep,
    watchlists: sourceOpenSanctionsRegulatory,
    posts_by_keywords: sourcePostsByKeywords,
    posts_comments: sourcePostsComments,
    public_company_info: sourcePublicCompanyInfo,
  }

  function returnSourcesByType(type: WorkflowType) {
    return sourcesByType[type]
  }

  function handleNext() {
    requestData.sources = returnSourcesByType(type)    
    if (type === 'additional_quotas'){
      setPrice(0)
    }
    if (type === 'webint' || type === 'additional_quotas' || type === 'profiler') {
      setErrors(null)
      setActiveStep(1)
      return
    }

    if (isFakeCheck == false ) {
      requestData.fakeCheckPrice = null
    }

    const error = validateForm(schema, requestData)
    if (error) {
      setErrors(error)
    }
    else {
      setErrors(null)
      setActiveStep(1)
    }
  }

  function handleSubmit() {
    requestData.sources = returnSourcesByType(type) 
    if (type === 'webint') {
      requestData.sources = webIntParams
      requestData.input = JSON.stringify(webIntInputObject)
    }
    if (type === 'additional_quotas') {
      requestData.sources = webIntParams
      requestData.input = JSON.stringify(additionalWebintQuota)
    }
    if (type === 'profiler') {
      requestData.input = JSON.stringify({ reportCountry: reportCountry })
    }

    if (mode === 'create') {
      console.log("requestData = ",requestData)
      dispatch(postWorkflow(requestData, () => tableRef.current?.refresh()))
    }
    else {
      dispatch(
        putWorkflow(requestData, data?.id as number, () =>
          tableRef.current?.refresh(),
        ),
      )
    }
    onClose()
  }

  const additionalWebintQuota = {
    additionalProfilerLookup : additionalProfilerLookup,
    additionalProfilerCrawlers : additionalProfilerCrawlers,
    additionalProfilerCases : additionalProfilerCases,
    additionalProfilerMonitoring : additionalProfilerMonitoring,
    additionalProfilerPeriodic : additionalProfilerPeriodic,
    additionalWebIntLookup : additionalWebIntLookup,
    additionalWebIntCrawlers : additionalWebIntCrawlers,
    additionalWebIntCases : additionalWebIntCases,
    additionalWebIntMonitoring : additionalWebIntMonitoring,
    additionalWebIntPeriodic : additionalWebIntPeriodic, 
  }

  const webIntInputObject = {
    quotaProfilerLookup : quotaProfilerLookup,
    quotaProfilerCrawlers : quotaProfilerCrawlers,
    quotaProfilerCases : quotaProfilerCases,
    quotaProfilerMonitoring : quotaProfilerMonitoring,
    quotaProfilerPeriodic : quotaProfilerPeriodic,
    quotaWebIntLookup : quotaWebIntLookup,
    quotaWebIntCrawlers : quotaWebIntCrawlers,
    quotaWebIntCases : quotaWebIntCases,
    quotaWebIntMonitoring : quotaWebIntMonitoring,
    quotaWebIntPeriodic : quotaWebIntPeriodic, 
    
    quotaTrialProfilerLookup : quotaTrialProfilerLookup,
    quotaTrialProfilerCrawlers : quotaTrialProfilerCrawlers,
    quotaTrialProfilerCases : quotaTrialProfilerCases,
    quotaTrialWebIntCrawlers : quotaTrialWebIntCrawlers,
    quotaTrialWebIntCases : quotaTrialWebIntCases,
    quotaTrialWebIntMonitoring : quotaTrialWebIntMonitoring,
    quotaTrialWebIntPeriodic : quotaTrialWebIntPeriodic,
  } 

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
  
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }
  
  function a11yProps(index: number) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    }
  }

  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Dialog open={true} fullWidth onClose={onClose}>
      <DialogTitle sx={{ fontSize: 20 }}>
        {mode === 'create' && t('package.create.lookup')}
        {mode === 'edit' && `${t('package.edit.lookup')}: ${data?.title}`}
        <IconButton className="button__close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Box my={2}>
        <Stepper
          steps={[t('package.steps.workflow'), t('package.steps.preview')]}
          activeStep={activeStep}
        />
      </Box>

      {activeStep === 0 ? (
        <Stack
          mb={3}
          spacing={2}
          sx={{ padding: 1, height: 530, overflowY: 'auto' }}
        >
          {/** Type */}
          <FormControl>
            <FormLabel>{t('field.label.type')}</FormLabel>
            <Select
              value={type}
              IconComponent={SelectIcon}
              onChange={(e) => handleTypeChange(e.target.value as WorkflowType)}
            >
              <MenuItem value="phone">Phone</MenuItem>
              <MenuItem value="name">Name (Crawlers)</MenuItem>
              <MenuItem value="name_api">Name Api (IRBIS SN)</MenuItem>
              <MenuItem value="post">Post</MenuItem>
              <MenuItem value="posts_by_keywords">Posts by keywords (IRBIS SN)</MenuItem>
              <MenuItem value="deepweb">Deep WEB</MenuItem>
              <MenuItem value="webint">WebInt</MenuItem>
              <MenuItem value="combined_phone">Advanced Phone Lookup</MenuItem>
              <MenuItem value="phone_list">Advanced Phone Lookup (List)</MenuItem>
              <MenuItem value="combined_email">Advanced E-mail Lookup</MenuItem>
              <MenuItem value="email_list">Advanced E-mail Lookup (List)</MenuItem>
              <MenuItem value="combined_name">Advanced Name Lookup</MenuItem>
              <MenuItem value="name_by_country">Advanced Name Lookup By Country</MenuItem>
              <MenuItem value="combined_id">Advanced ID Lookup</MenuItem>
              <MenuItem value="face_search">Face Search</MenuItem>
              <MenuItem value="additional_quotas">Add Quotas</MenuItem>
              <MenuItem value="web_data_search">Facebook API (Crawlers)</MenuItem>
              <MenuItem value="irbis_facebook">Facebook API (IRBIS SN)</MenuItem>
              <MenuItem value="irbis_instagram">Instagram API (IRBIS SN)</MenuItem>
              <MenuItem value="crolo_x">X API (IRBIS SN)</MenuItem>
              <MenuItem value="crolo_vk">Vk API (IRBIS SN)</MenuItem>
              <MenuItem value="crolo_ok">Ok API (IRBIS SN)</MenuItem>
              <MenuItem value="irbis_tiktok">TikTok API (IRBIS SN)</MenuItem>
              <MenuItem value="bluesky_v3">BlueSky API (IRBIS SN)</MenuItem>
              <MenuItem value="fb_person_wall_keyword">Facebook API (person wall keyword, Crawlers)</MenuItem>
              <MenuItem value="sentiment_analysys">Sentiment Analysys</MenuItem>
              <MenuItem value="irbis_eye">Irbis Eye</MenuItem>
              <MenuItem value="image_insize">Photo Intel</MenuItem>
              <MenuItem value="photo_searcher">Sniper API</MenuItem>
              <MenuItem value="kyc">KYC</MenuItem>
              <MenuItem value="web_collection">WEB Collection</MenuItem>
              <MenuItem value="ip_geo">Geolocation</MenuItem>
              <MenuItem value="ipgeo_number">Geolocation By Phone</MenuItem>
              <MenuItem value="psycho_profile">PsychoProfile and Summary</MenuItem>
              <MenuItem value="api_v2_x">API v.2 - X (Twitter)</MenuItem>
              <MenuItem value="api_v2_instagram">API v.2 - Instagram</MenuItem>
              <MenuItem value="api_v2_linkedin">API v.2 - LinkedIn</MenuItem>
              <MenuItem value="lookup_phone_verification">Validate Phone Lookup Results</MenuItem>
              <MenuItem value="lookup_phone_name_verification">Validate Phone Lookup By Name</MenuItem>
              <MenuItem value="real_phone">Real Phone</MenuItem>
              <MenuItem value="irbis_criminal">Irbis Criminal Checks (Out of date)</MenuItem>
              <MenuItem value="ssn_trace">Social Security Number Trace</MenuItem>
              <MenuItem value="nat_crim_check">National Criminal Screening</MenuItem>
              <MenuItem value="pep">Politically Exposed Persons</MenuItem>
              <MenuItem value="sanctions_person_company">Open Sanctions (Person\Company)</MenuItem>
              <MenuItem value="sanctions_pep">Open Sanctions (PEP)</MenuItem>
              <MenuItem value="watchlists">Open Sanctions (Watchlists)</MenuItem>
              <MenuItem value="court_records">Court Records</MenuItem>
              <MenuItem value="crypto_wallet_screening">Crypto Wallet Screening</MenuItem>
              <MenuItem value="region_monitoring">Region Monitoring</MenuItem>
              <MenuItem value="region_monitoring_entities_extract">Region Monitoring (Entities Extract)</MenuItem>
              <MenuItem value="irbispro_conclude_report">Irbis Pro Conclude Report</MenuItem>
              <MenuItem value="adid">AdID (get AdID by coordinates)</MenuItem>
              <MenuItem value="adid_by_phone">AdID (get AdId by phone number)</MenuItem>
              <MenuItem value="adid_location">AdID (get location by AdId)</MenuItem>
              <MenuItem value="profiler">Irbis Profiler</MenuItem>
              <MenuItem value="group_members">Group Members Info</MenuItem>
              <MenuItem value="psycho_profile_summary">OSINT: PsychoProfile</MenuItem>
              <MenuItem value="public_company_info">Public Information about a company</MenuItem>
              <MenuItem value="sn_api_profiler">OSINT: Social Network API Profiler (Common Profile Builder)</MenuItem>
              <MenuItem value="sn_api_profiler_fb_friends">OSINT: Social Network API Profiler (Facebook Friends)</MenuItem>
              <MenuItem value="sn_api_profiler_fb_posts">OSINT: Social Network API Profiler (Facebook Posts)</MenuItem>
              <MenuItem value="sn_api_profiler_insta_friends">OSINT: Social Network API Profiler (Instagram Friends)</MenuItem>
              <MenuItem value="sn_api_profiler_insta_posts">OSINT: Social Network API Profiler (Instagram Posts)</MenuItem>
              <MenuItem value="sn_api_group_profiler">WEBINT: Social Network API Profiler (Group Profile Builder)</MenuItem>
              <MenuItem value="posts_comments">Posts and Comments</MenuItem>
            </Select>
          </FormControl>
          {/** Title */}
          <FormControl fullWidth>
            <FormLabel required>{t('field.label.title')}</FormLabel>
            <OutlinedInput
              value={title}
              placeholder={t('field.hint.title')}
              onChange={(e) => setTitle(e.target.value)}
            />
            <FormError error={errors?.title} />
          </FormControl>

          {/** Subtitle */}
          <FormControl fullWidth>
            <FormLabel required>{t('field.label.subTitle')}</FormLabel>
            <OutlinedInput
              value={subTitle}
              placeholder={t('field.hint.subtitle')}
              onChange={(e) => setSubTitle(e.target.value)}
            />
            <FormError error={errors?.subTitle} />
          </FormControl>

          {/** Price */}
          { type !== 'webint' && type !== 'additional_quotas' &&
          <FormControl fullWidth>
            <FormLabel required>{t('field.label.price')}</FormLabel>
            <OutlinedInput
              type="number"
              value={price}
              startAdornment={
                <InputAdornment position="start">€</InputAdornment>
              }
              onChange={(e) => setPrice(Number(e.target.value))}
              inputProps={{
                min: 0,
                max: 99,
              }}
            />
            <FormError error={errors?.price} />
          </FormControl>
          }
          {type === 'profiler' &&
            <CountrySingleSelect
              type={type}
              value={reportCountry}
              onChange={setCountry}
              t={t}
            />
          }
          {type === 'combined_phone' &&
            <FormControl fullWidth>
              <Stack direction="row" alignItems="center">
                <FormControlLabel
                  control={<InputCheckbox defaultChecked={isFakeCheck} />}
                  label="Fake Check price"
                  onChange={handleFakeCheckPrice}

                />
              </Stack>
              <OutlinedInput
                type="number"
                value={fakeCheckPrice}
                disabled={!isFakeCheck}
                startAdornment={
                  <InputAdornment position="start">€</InputAdornment>
                }
                onChange={(e) => setFakeCheckPrice(Number(e.target.value))}
                inputProps={{
                  min: 0,
                  max: 99,
                }}
              />
              <FormError error={errors?.price} />
            </FormControl>
          }
          {type === 'phone_list' &&
            <FormControl fullWidth>
              <FormLabel required>{"Max numbers in list:"}</FormLabel>
              <OutlinedInput
                type="number"
                value={maxNum}
                onChange={(e) => setMaxNum(Number(e.target.value))}
              />
              <FormError error={errors?.price} />
            </FormControl>
          }
          {type === 'email_list' &&
            <FormControl fullWidth>
              <FormLabel required>{"Max e-mails in list:"}</FormLabel>
              <OutlinedInput
                type="number"
                value={maxNum}
                onChange={(e) => setMaxNum(Number(e.target.value))}
              />
              <FormError error={errors?.price} />
            </FormControl>
          }

          {/** Sources */}
          <FormControl fullWidth>
            { (type !== 'webint' && type !== 'sn_api_profiler_fb_friends' && 
            type !== 'sn_api_profiler_fb_posts' && type !== 'sn_api_profiler_insta_friends' &&
            type !== 'sn_api_profiler_insta_posts' ) &&
            <FormLabel required>{t('field.label.sources')}</FormLabel>
            }
            <Grid container>
                {type === 'phone' &&
                phones.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourcePhone)}
                        onChange={() => handlePhoneSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'phone_list' &&
                phoneList.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourcePhoneList)}
                        onChange={() => handleListPhoneSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'email_list' &&
                emailList.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceEmailList)}
                        onChange={() => handleListEmailSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'name' &&
                socials.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceSocial)}
                        onChange={() => handleSocialSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))} 
                {type === 'name_api' &&
                nameApi.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceNameApi)}
                        onChange={() => handleNameApiSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
              {type === 'crolo_x' &&
                crolo_x.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceCroloX)}
                        onChange={() => handleCroloXSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'crolo_vk' &&
                crolo_vk.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceCroloVk)}
                        onChange={() => handleCroloVkSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'crolo_ok' &&
                crolo_ok.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceCroloOk)}
                        onChange={() => handleCroloOkSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'irbis_criminal' &&
                irbis_criminal.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceIrbisCriminal)}
                        onChange={() => handleIrbisCriminalSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'ssn_trace' &&
                ssn_trace.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceSsnTrace)}
                        onChange={() => handleSsnTraceSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'nat_crim_check' &&
                nat_crim_check.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceNatCrimCheck)}
                        onChange={() => handleNatCrimCheckSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'pep' &&
                pep.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourcePep)}
                        onChange={() => handlePepSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'court_records' &&
                court_records.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceCourtRecords)}
                        onChange={() => handleCourtRecordsSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'crypto_wallet_screening' &&
                cryptoWalletScreening.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceCryptoWalletScreening)}
                        onChange={() => handleCryptoWalletScreeningSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'region_monitoring' &&
                regionMonitoring.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceRegionMonitoring)}
                        onChange={() => handleRegionMonitoringSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'region_monitoring_entities_extract' &&
                regionMonitoringEntitiesExtract.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceRegionMonitoringEntitiesExtract)}
                        onChange={() => handleRegionMonitoringEntitiesExtractSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'irbispro_conclude_report' &&
                irbisProConcludeReport.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceIrbisProConcludeReport)}
                        onChange={() => handleIrbisproConcludeReportSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'adid' &&
                adid.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceAdid)}
                        onChange={() => handleAdidSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'adid_by_phone' &&
                adid_by_phone.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceAdidByPhone)}
                        onChange={() => handleAdidByPhoneSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'adid_location' &&
                adid_location.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceAdidLocation)}
                        onChange={() => handleAdidLocationSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'group_members' &&
                group_members.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceGroupMembers)}
                        onChange={() => handleGroupMembersSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'irbis_tiktok' &&
                irbis_tiktok.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceIrbisTikTok)}
                        onChange={() => handleIrbisTikTokSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
              {type === 'bluesky_v3' &&
                bluesky.map((el) => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceBlueSky)}
                        onChange={() => handleIrbisBlueSkySourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))
              }
                {type === 'post' &&
                postLookups.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceSocial)}
                        onChange={() => handleSocialSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'deepweb' &&
                deepWebLookups.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceDeepWeb)}
                        onChange={() => handleDeepWebChange(el)}
                      />
                      <Box className={sprite_['social__small_'+el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'sentiment_analysys' &&
                sentimentAnalysys.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceSentiment)}
                        onChange={() => handleSentimentAnalysysChange(el)}
                      />
                      <Box className={sprite_['social__small_'+el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'kyc' &&
                kyc.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceKYC)}
                        onChange={() => handleKYCChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'web_collection' &&
                web_collection.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceWebCollection)}
                        onChange={() => handleWebCollectionChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'ip_geo' &&
                ip_geo.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceIPGeo)}
                        onChange={() => handleIPGeoChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'ipgeo_number' &&
                geolocation_by_number.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceIPGeoByNumber)}
                        onChange={() => handleIPGeoByNumberChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'name_by_country' &&
                nameByCountry.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceNameByCountry)}
                        onChange={() => handleNameByCountry(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'irbis_eye' &&
                findClone.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceFindClone)}
                        onChange={() => handleFindCloneChange(el)}
                      />
                      <Box className={sprite_['social__small_'+el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'photo_searcher' &&
                sniperAPI.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceSniperApi)}
                        onChange={() => handleSniperApiChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'web_data_search' && 
                advancedCollectionLookups.map( el => (
                      <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceAdvancedCollection)}
                        onChange={() => handleAddvancedSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'irbis_facebook' && 
                fbMobileCollectorLookups.map( el => (
                      <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceFbMobileCollector)}
                        onChange={() => handleFbMobileCollectorSorceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'irbis_instagram' && 
                instaMobileCollectorLookups.map( el => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceInstaMobileCollector)}
                        onChange={() => handleInstaMobileCollectorSorceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'api_v2_x' && 
                api_v2_x.map( el => (
                      <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceAPIv2X)}
                        onChange={() => handleAPIv2XChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'api_v2_instagram' && 
                api_v2_instagram.map( el => (
                      <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceAPIv2Instagram)}
                        onChange={() => handleAPIv2InstagramChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'api_v2_linkedin' && 
                api_v2_linkedin.map( el => (
                      <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceAPIv2LinkedIn)}
                        onChange={() => handleAPIv2LinkedInChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}  
                {type === 'sn_api_profiler' && 
                sn_api_profile.map( el => (
                      <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceSnAPIProfiler)}
                        onChange={() => handleSnAPIProfilerChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'sn_api_group_profiler' && 
                sn_api_group_profile.map( el => (
                      <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceSNApiWebintGroupProfile)}
                        onChange={() => handleSNApiWebintGroupProfileChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'fb_person_wall_keyword' &&
                advCollectionPersonWallLookups.map(el => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceAdvCollectionSourcePersonWall)}
                        onChange={() => handleAdvCollectionSourcePersonWall(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'psycho_profile' &&
                psychoProfile.map(el => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourcePsychoProfile)}
                        onChange={() => handlePsychoProfileChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'psycho_profile_summary' &&
                psychoProfile.map(el => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourcePsychoProfile)}
                        onChange={() => handlePsychoProfileChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'image_insize' &&
                image_insize.map(el => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceImageInsize)}
                        onChange={() => handleImageInsize(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'profiler' &&
                profiler.map(el => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceProfiler)}
                        onChange={() => handleProfiler(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'sanctions_person_company' &&
                openSanctions.map(el => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceOpenSanctions)}
                        onChange={() => handleOpenSanctions(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'sanctions_pep' &&
                openSanctionsPep.map(el => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceOpenSanctionsPep)}
                        onChange={() => handleOpenSanctionsPep(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'watchlists' &&
                openSanctionsRegulatory.map(el => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceOpenSanctionsRegulatory)}
                        onChange={() => handleOpenSanctionsRegulatory(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'posts_by_keywords' &&
                postsByKeywords.map(el => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourcePostsByKeywords)}
                        onChange={() => handlePostsByKeywords(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'posts_comments' &&
                postsComments.map(el => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourcePostsComments)}
                        onChange={() => handlePostsComments(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'lookup_phone_verification' &&
                lookup_phone_verification.map(el => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceLookupPhoneValidator)}
                        onChange={() => handleLookupPhoneValidator(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'public_company_info' &&
                publicCompanyInfo.map(el => (
                  <Grid key={el} item xs={6}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourcePublicCompanyInfo)}
                        onChange={() => handlePublicCompanyInfo(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'webint' &&
                <Box
                sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}
                >
                <Tabs
                  orientation="vertical"
                  variant="scrollable"
                  value={value}
                  onChange={handleChange}
                  aria-label="Vertical tabs example"
                  sx={{ borderRight: 1, borderColor: 'divider' }}
                >
                  <Tab label="Quota" {...a11yProps(0)} />
                  <Tab label="Trial" {...a11yProps(1)} />

                </Tabs>
                <TabPanel value={value} index={0}>
                <FormControl fullWidth required>
                <Grid container >
                <Grid item xs = {6} >
                <Box  component="form" sx={{"& .MuiTextField-root": { m: 1, width: "100%" }, display : 'flex', flexDirection: 'column', p: 1, alignItems: 'center'}} noValidate   >
                <Typography ml={1}>Profiler</Typography>
                <TextField value={quotaProfilerLookup} onChange={ (e) => setQuotaProfilerLookup(e.target.value)} label="Phone numbers" type="number"  defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={quotaProfilerCrawlers} onChange={ (e) => setQuotaProfilerCrawlers(e.target.value)} required id="outlined-number" label="Social networks" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={quotaProfilerCases} onChange={ (e) => setQuotaProfilerCases(e.target.value)} required id="outlined-number" label="Cases" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                </Box>
                </Grid>
                <Grid item xs = {6} >
                <Box  component="form" sx={{"& .MuiTextField-root": { m: 1, width: "100%" }, display : 'flex', flexDirection: 'column', p: 1, alignItems: 'center'}} noValidate autoComplete="off">
                <Typography>WebInt</Typography>
                <TextField value={quotaWebIntCrawlers} onChange={ (e) => setQuotaWebIntCrawlers(e.target.value)} required id="outlined-number" label="Tasks" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={quotaWebIntCases} onChange={ (e) => setQuotaWebIntCases(e.target.value)} required id="outlined-number" label="Cases" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={quotaWebIntMonitoring} onChange={ (e) => setQuotaWebIntMonitoring(e.target.value)} required id="outlined-number" label="Monitored groups" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                </Box>
                </Grid>
                </Grid>
                <Grid item xs = {8} >
                <Box  component="form" sx={{"& .MuiTextField-root": { m: 1, width: "50%" }, display : 'flex', flexDirection: 'row-reverse', p: 0, alignItems: 'center'}} noValidate autoComplete="off">
                <TextField value={quotaWebIntPeriodic} onChange={ (e) => setQuotaWebIntPeriodic(e.target.value)} required id="outlined-number" label="Expired in (days):" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/> 
                </Box>
                </Grid>
                </FormControl>
                </TabPanel>
                <TabPanel value={value} index={1}>
                <FormControl fullWidth required>
                <Grid container >
                <Grid item xs = {6} >
                <Box  component="form" sx={{"& .MuiTextField-root": { m: 1, width: "100%" }, display : 'flex', flexDirection: 'column', p: 1, alignItems: 'center'}} noValidate autoComplete="off">
                <Typography ml={1}>Profiler</Typography>
                <TextField value={quotaTrialProfilerLookup} onChange={ (e) => setQuotaTrialProfilerLookup(e.target.value)} required id="outlined-number" label="Phone numbers" type="number"  defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={quotaTrialProfilerCrawlers} onChange={ (e) => setQuotaTrialProfilerCrawlers(e.target.value)} required id="outlined-number" label="Social networks" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={quotaTrialProfilerCases} onChange={ (e) => setQuotaTrialProfilerCases(e.target.value)} required id="outlined-number" label="Cases" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                </Box>
                </Grid>
                <Grid item xs = {6} >
                <Box  component="form" sx={{"& .MuiTextField-root": { m: 1, width: "100%" }, display : 'flex', flexDirection: 'column', p: 1, alignItems: 'center'}} noValidate autoComplete="off">
                <Typography>WebInt</Typography>
                <TextField value={quotaTrialWebIntCrawlers} onChange={ (e) => setQuotaTrialWebIntCrawlers(e.target.value)} required id="outlined-number" label="Tasks" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={quotaTrialWebIntCases} onChange={ (e) => setQuotaTrialWebIntCases(e.target.value)} required id="outlined-number" label="Cases" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={quotaTrialWebIntMonitoring} onChange={ (e) => setQuotaTrialWebIntMonitoring(e.target.value)} required id="outlined-number" label="Monitored groups" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                </Box>
                </Grid>
                </Grid>
                <Grid item xs = {8} >
                <Box  component="form" sx={{"& .MuiTextField-root": { m: 1, width: "50%" }, display : 'flex', flexDirection: 'row-reverse', p: 0, alignItems: 'center'}} noValidate autoComplete="off">
                <TextField value={quotaTrialWebIntPeriodic} onChange={ (e) => setQuotaTrialWebIntPeriodic(e.target.value)} required id="outlined-number" label="Expired in (days):" type="number" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/> 
                </Box>
                </Grid>
                </FormControl>
                </TabPanel>
                </Box>
                }
                {type === 'additional_quotas' &&
                <Box
                sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}
                >
                <Tabs
                  orientation="vertical"
                  variant="scrollable"
                  value={value}
                  onChange={handleChange}
                  aria-label="Vertical tabs example"
                  sx={{ borderRight: 1, borderColor: 'divider' }}
                >
                <Tab label="Quota" {...a11yProps(0)} />
                </Tabs>
                <TabPanel value={value} index={0}>
                <FormControl fullWidth required>
                <Grid container >
                <Grid item xs = {6} >
                <Box  component="form" sx={{"& .MuiTextField-root": { m: 1, width: "100%" }, display : 'flex', flexDirection: 'column', p: 1, alignItems: 'center'}} noValidate   >
                <Typography ml={1}>Profiler</Typography>
                <TextField value={additionalProfilerLookup} onChange={ (e) => setAdditionalProfilerLookup(e.target.value)} label="Phone numbers" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={additionalProfilerCrawlers} onChange={ (e) => setAdditionalProfilerCrawlers(e.target.value)} required id="outlined-number" label="Social networks"  defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={additionalProfilerCases} onChange={ (e) => setAdditionalProfilerCases(e.target.value)} required id="outlined-number" label="Cases"  defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                </Box>
                </Grid>
                <Grid item xs = {6} >
                <Box  component="form" sx={{"& .MuiTextField-root": { m: 1, width: "100%" }, display : 'flex', flexDirection: 'column', p: 1, alignItems: 'center'}} noValidate autoComplete="off">
                <Typography>WebInt</Typography>
                <TextField value={additionalWebIntCrawlers} onChange={ (e) => setAdditionalWebIntCrawlers(e.target.value)} required id="outlined-number" label="Tasks" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={additionalWebIntCases} onChange={ (e) => setAdditionalWebIntCases(e.target.value)} required id="outlined-number" label="Cases"  defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                <TextField value={additionalWebIntMonitoring} onChange={ (e) => setAdditionalWebIntMonitoring(e.target.value)} required id="outlined-number" label="Monitored groups" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/>
                </Box>
                </Grid>
                </Grid>
                <Grid item xs = {8} >
                <Box  component="form" sx={{"& .MuiTextField-root": { m: 1, width: "50%" }, display : 'flex', flexDirection: 'row-reverse', p: 0, alignItems: 'center'}} noValidate autoComplete="off">
                <TextField value={additionalWebIntPeriodic} disabled hidden={true} onChange={ (e) => setAdditionalWebIntPeriodic(e.target.value)} required id="outlined-number" label="Expired in (days):" defaultValue={1} InputLabelProps={{shrink: true}} inputProps={{min: 1, style: { textAlign: 'center' }}}/> 
                </Box>
                </Grid>
                </FormControl>
                </TabPanel>
                </Box>
                }
                {type === 'combined_phone' &&
                combinedPhones.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceCombinedPhones)}
                        onChange={() => handleCombinePhoneSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'combined_email' &&
                combinedEmails.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceCombinedEmails)}
                        onChange={() => handleCombineEmailsSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'combined_name' &&
                combinedNames.map((el) => (
                  ( el !== 'fb_api' && el !== 'instagram_api' && el !== 'vk_api' && el !== 'ok_api' 
                    && el !== 'x_api' && el !== 'linkedin_api' && el !== 'tiktok_api' && el !== 'blsk_api' 
                      && el!== 'webmii_social' && el!== 'breach_name' && el!== 'snapchat') && ( 
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceCombinedNames)}
                        onChange={() => handleCombineNamesSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                  )
                ))
                }
                {type === 'combined_id' &&
                combinedIds.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceCombinedId)}
                        onChange={() => handleCombineidSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                {type === 'face_search' &&
                faceSearches.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceFaceSearch)}
                        onChange={() => handleFaceSearch(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
                { (type === 'lookup_phone_name_verification' || type === 'real_phone') && 
                combinedPhones.map((el) => (
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceCombinedPhones)}
                        onChange={() => handleCombinePhoneSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                ))}
            </Grid>
            {type === 'combined_name' &&
              <Stack>
                <Divider>
                  <Chip label="Irbis Social" size="small" style={{ marginBottom: -20 }} sx={{
                    color: '#000000',
                  }} />
                </Divider>
              </Stack>
            }
              <Grid container style={{ marginTop: '10px' }} >
              {type === 'combined_name' && 
              combinedNames.map((el) => (
                  ( el === 'fb_api' || el === 'instagram_api' || el === 'vk_api' || el === 'ok_api'  
                    || el === 'x_api' || el === 'linkedin_api' || el === 'tiktok_api' || el === 'blsk_api' 
                      || el === 'webmii_social' || el === 'breach_name' || el == 'snapchat') && ( 
                  <Grid key={el} item xs={4}>
                    <Stack direction="row" alignItems="center">
                      <InputCheckbox
                        checked={isSourceChecked(el, sourceCombinedNames)}
                        onChange={() => handleCombineNamesSourceChange(el)}
                      />
                      <Box className={sprite_['social__small_' + el.replace("_api", "")]} />
                      <Typography textTransform="capitalize" ml={1}>
                        {getSourceName(el)}
                      </Typography>
                    </Stack>
                  </Grid>
                  )
                ))
              }
              </Grid>
            
            {/* <FormError error={errors?.sources} /> */}
          </FormControl>
          {
          ( ['irbis_facebook', 'irbis_instagram', 'web_data_search', 'fb_person_wall_keyword', 'crolo_x', 'crolo_vk', 'crolo_ok', 'irbis_tiktok', 
              'bluesky_v3', 'api_v2_x', 'api_v2_instagram', 'api_v2_linkedin', 
                'ssn_trace', 'nat_crim_check', 'pep', 'court_records'].includes(type) )  && (
            <FormControl fullWidth>
              <Stack direction="row" alignItems="center">
                <FormControlLabel
                  control={<InputCheckbox defaultChecked={isAiSummarizing} />}
                  label="AI data summarizing"
                  onChange={handleAIsummarizingPrice}
                />
              </Stack>
              <OutlinedInput
                type="number"
                value={aiSummarizingPrice}
                disabled={!isAiSummarizing}
                startAdornment={
                  <InputAdornment position="start">€</InputAdornment>
                }
                onChange={(e) => setAiSummarizingPrice(Number(e.target.value))}
                inputProps={{
                  min: 0,
                  max: 99,
                }}
              />
              <FormError error={errors?.price} />
            </FormControl>
          )}

          {/** Input */}
          { type !== 'webint' && type !== 'additional_quotas' && type !== "web_data_search" && type !== "fb_person_wall_keyword" && type !== 'ipgeo_number' && type !== 'profiler' && 
          <FormControl fullWidth required>
            <FormLabel>{t('field.label.input')}</FormLabel>
            <OutlinedInput
              value={input}
              placeholder={t('field.hint.input')}
              onChange={(e) => setInput(e.target.value)}
            />
            <FormError error={errors?.input} />
          </FormControl>
          } 

          {/** Input for IP - Number */}
          { type === 'ipgeo_number' && 
          <FormControl fullWidth required>
            <FormLabel>{t('field.label.inputPhone')}</FormLabel>
            <OutlinedInput
              value={input}
              placeholder={t('field.hint.inputPhone')}
              onChange={(e) => setInput(e.target.value)}
            />
            <FormError error={errors?.input} />
            <FormLabel>{t('field.label.inputIP')}</FormLabel>
            <OutlinedInput
              value={inputIP}
              placeholder={t('field.hint.inputIP')}
              onChange={(e) => setInputIP(e.target.value)}
            />
            <FormError error={errors?.inputIP} />
          </FormControl>
          } 


          { (type === "web_data_search" || type === "fb_person_wall_keyword") && 
          <FormControl fullWidth required>
            <FormLabel>{t('field.label.limit')}</FormLabel>
            <OutlinedInput
              value={input}
              placeholder={t('field.hint.limit')}
              onChange={(e) => setInput(e.target.value)}
            />
            <FormError error={errors?.input} />
          </FormControl>
          } 

          {/** Button */}
          <FormControl fullWidth required>
            <FormLabel>{t('field.label.button')}</FormLabel>
            <OutlinedInput
              value={button}
              placeholder={t('field.hint.text')}
              onChange={(e) => setButton(e.target.value)}
            />
            <FormError error={errors?.button} />
          </FormControl>

          {/** Color */}
          <InputColor color={color} onChange={(color) => setColor(color.hex)} />
        </Stack>
      ) : (
        <Stack
          alignItems="center"
          mb={2}
          sx={{
            padding: 2,
            minHeight: 174,
            bgcolor: colorBackground,
            overflowY: 'auto',
          }}
        >
          <PreviewLookup data={requestData} type={type}/>
        </Stack>
      )}

      <PopupActions
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        handleNext={handleNext}
        handleSubmit={handleSubmit}
        onClose={onClose}
      />
    </Dialog>
  )
}
